<template>
  <section aria-label="Panorama viewer" class="a-cover">
    <div id="pano" class="h-full z-0" />

    <!-- <webVrGyroBtns -->
    <!--   class="absolute top&#45;3 right&#45;3" -->
    <!--   @toggleGyro="toggleGyro" -->
    <!--   @enterVr="enterVr" -->
    <!-- /> -->
  </section>
</template>

<script>
/* global removepano: false, embedpano: false */
import { mapState, mapGetters } from 'vuex'
import { bus } from '@/main'

import webVrGyroBtns from '@/components/buttons/webVrGyroBtns.vue'

export default {
  name: 'Panorama',

  components: {
    webVrGyroBtns
  },

  props: {
    post: {
      type: Object,
      default: () => {}
    },
    location: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    palette: {
      type: Object,
      default: () => {}
    },
    isCampus: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      pano: '',
      hotspots: []
    }
  },

  computed: {
    ...mapState(['mobile', 'touch', 'sidebarOpen']),
    ...mapGetters([])
  },

  watch: {
    post(newVal, oldVal) {
      const newId = newVal.panorama.id
      const oldId = oldVal.panorama.id
      const updatePano = newId !== oldId

      if (updatePano) {
        this.krpTour()
      } else {
        this.krpRemoveSpots()
        this.krpAddSpots()
      }
    }
  },

  mounted() {
    embedpano({
      xml: 'vendor/krpano.xml',
      target: 'pano',
      id: 'rama',
      mobilescale: 1.0,
      wmode: 'transparent',
      onready: this.krpReady
    })

    bus.$on('panToHotSpot', this.showFromSidebar)
    bus.$on('closeHotSpot', this.hideFromSidebar)

    document.getElementById('rama').addEventListener('focus', () => {
      this.$announcer.set(this.post.panorama.description)
    })
  },

  beforeDestroy() {
    removepano('rama')
    this.pano = false
    document.removeEventListener('focus', () => {})
  },

  methods: {
    krpReady(rama) {
      this.pano = rama
      this.pano.setAttribute('tabindex', 0)
      window.activekrpanowindow = 'rama'

      window.onSpotLoaded = this.onSpotLoaded
      window.onSpotClick = this.onSpotClick
      // window.onNavSpotClick = this.onNavSpotClick
      // window.rvonentervr = this.rvonentervr
      // window.rvonexitvr = this.rvonexitvr
      // window.rvvrnext = this.rvvrnext
      // window.rvvrprevious = this.rvvrprevious

      this.krpTour()
    },

    krpTour() {
      const krpScene = `
        <krpano>
          <view
            fov="80.0"
            fovmin="65"
            fovmax="105"
            limitview="lookat"
            hlookat="${this.post.position.horizontal}"
            vlookat="${this.post.position.vertical}"
            hlookatmin="${this.post.corners.west}"
            hlookatmax="${this.post.corners.east}"
            vlookatmin="-90"
            vlookatmax="90"
            fisheye="0"/>
          <preview url="${
            this.post.panorama.sizes.medium
          }?nocache=${Date.now()}"/>
          <image>
            <sphere url="${this.post.panorama.url}"/>
          </image>
        </krpano>
      `

      const krpCall = `loadxml(${krpScene}, null, MERGE, blend(1, linear)); }`

      this.pano.call(krpCall)

      this.krpAddSpots()
    },

    krpRemoveSpots() {
      const landmarks = this.post.children
        .filter(({ location_type }) => location_type === 'landmark_location')
        .map(item => item.slug)

      const spots = this.pano
        .get('hotspot')
        .getArray()
        .filter(
          item =>
            !['followmenuprev', 'followmenunext', ...landmarks].includes(
              item.name
            )
        )
        .map(item => {
          return `removehotspot(${item.name});`
        })
        .join('')

      const krpCall = `${spots}`

      this.pano.call(krpCall)
    },

    krpAddSpots() {
      const hotspots = this.post.children.reduce((crop, item) => {
        const slug = `${item.slug}`

        const icon = this.isCampus
          ? `marker-${this.palette.primary}`
          : this.location.type === 'tour'
          ? `${item.type}-white`
          : item.type

        const img =
          this.isCampus && item.image
            ? { src: item.image.sizes.thumbnail, alt: item.image.alt }
            : { src: '', alt: '' }

        const color = this.isCampus
          ? 'bg-transparent'
          : `bg-${this.palette.primary}`

        const classes = {
          marker: {
            icon: 'h-10 w-10 mr-2 mt-2',
            popup: `pl-10`
          },
          hotspot: { icon: 'h-8 w-8', popup: `pl-16` }
        }

        const styles = this.isCampus ? classes.marker : classes.hotspot

        const hotspot = `
          <button role="link" aria-label="${
            item.title
          }" class="hotspot group relative h-14 text-base rounded-full focus-a font-sans">
            <div class="popup absolute left-0 top-0 h-full pr-10 bg-white rounded-full opacity-0 transition ${
              styles.popup
            }">
              <div class="h-full flex-c">
                <div>
                  <span class="block mr-1"> ${item.title} </span>
                </div>
                <img src="${require(`@/assets/icon-chevron-circle.svg`)}" alt="" class="absolute right-3 h-6 w-6 rotate-180">
              </div>
            </div>

            <div class="relative flex-c h-14 w-14 ${color} rounded-full">
              <img src="${require(`@/assets/icon-${icon}.svg`)}" alt="" role="presentation" class="relative ${
          styles.icon
        }" />
            </div>
          </button>
        `

        const landmark = `
          <button aria-label="${item.title}" class="hotspot relative group h-16 w-16 rounded-full focus-a text-base font-bold font-sans">
            <div class="popup absolute left-0 top-0 h-full pl-20 pr-8 bg-white rounded-full opacity-0 transition ${styles.popup}">
              <div class="h-full flex-c">
                <div>
                  <span class="block"> ${item.title} </span>
                  <span class="font-light"> ${item.landmark_info} </span>
                </div>
              </div>
            </div>
            <div class="relative h-full w-full rounded-full border border-white">
              <img src="${img.src}" alt="${img.alt}" class="h-full w-full rounded-full" />
            </div>
          </button>
        `

        const spot =
          item.location_type === 'landmark_location' ? landmark : hotspot

        return `
          ${crop}
          addhotspot(${slug});
          set(hotspot[${slug}].ath, ${item.horizontal});
          set(hotspot[${slug}].atv, ${item.vertical});
          set(hotspot[${slug}].type, text);
          set(hotspot[${slug}].html, '${escape(spot)}');
          set(hotspot[${slug}].padding, 0);
          set(hotspot[${slug}].wordwrap, false);
          set(hotspot[${slug}].interactivecontent, true);
          set(hotspot[${slug}].zoom, false);
          set(hotspot[${slug}].bg, false);
          set(hotspot[${slug}].renderer, css3d);
          set(hotspot[${slug}].onclick, looktohotspot(${slug}, 50); js(onSpotClick(${slug})));
          set(hotspot[${slug}].onloaded, js(onSpotLoaded(${slug})));

        `
      }, '')

      const krpCall = `${hotspots}`

      this.pano.call(krpCall)
    },

    getSprite(slug) {
      return this.pano.get(`hotspot[${slug}].sprite`)
    },

    onSpotClick(slug) {
      this.$emit('hotSpotClick', slug)
    },

    panToHotSpot(slug) {
      this.pano.call(`looktohotspot(${slug}, 50);`)
    },

    showHotSpotPopup(sprite) {
      const popup = sprite.querySelector('.popup')
      sprite.style.zIndex = 2002
      popup.classList.add('opacity-100', 'pointer-events-auto')
    },

    hideHotSpotPopup(sprite) {
      try {
        const popup = sprite.querySelector('.popup')
        sprite.style.zIndex = 2001
        popup.classList.remove('opacity-100', 'pointer-events-auto')
      } catch (err) {
        console.log()
      }
    },

    onSpotLoaded(slug) {
      const sprite = this.getSprite(slug)

      // Why oh why to we have to wait to get the button element...
      setTimeout(() => {
        const target = sprite.querySelector('.hotspot')

        // To keep track of a click or a focus key event
        let mouseDown = false

        // Try block as errors when guided tour intro is open
        // Think it's because the pano is aria hidden ??
        try {
          target.addEventListener('mousedown', () => {
            mouseDown = true
          })

          target.addEventListener('mouseup', () => {
            mouseDown = false
          })

          target.addEventListener('mouseover', () => {
            if (!this.touch) {
              this.showHotSpotPopup(sprite)
            }
          })

          target.addEventListener('mouseleave', () => {
            this.hideHotSpotPopup(sprite)
          })

          target.addEventListener('focus', e => {
            if (!mouseDown) {
              this.showHotSpotPopup(sprite)
              this.panToHotSpot(slug)
            }

            e.target.addEventListener('keyup', () => {
              const key = event.key || event.keyCode
              if (key === 'Enter' || key === '13') {
                this.onSpotClick(slug)
              }

              if (key === 'Escape' || key === '27') {
                this.hideHotSpotPopup(sprite)
                document.getElementById('rama').focus()
              }
            })
          })

          target.addEventListener('blur', e => {
            this.hideHotSpotPopup(sprite)
            e.target.removeEventListener('keyup', () => {})
          })
        } catch (err) {
          console.log()
        }
      }, 10)
    },

    showFromSidebar(slug) {
      const sprite = this.getSprite(slug)

      if (!this.touch) {
        this.showHotSpotPopup(sprite)
      }

      this.panToHotSpot(slug)
    },

    hideFromSidebar(slug) {
      const sprite = this.getSprite(slug)

      if (!this.touch) {
        this.hideHotSpotPopup(sprite)
      }
    },

    toggleGyro() {
      this.pano.call('switch(plugin[gyro].enabled)')
    },

    enterVr() {
      this.pano.call('webvr.toggleVR()')
    },

    rvonentervr() {
      this.pano.call(
        'set(events[vr_events].onviewchange, followMenuAction()); set(hotspot[followMenuPrev].visible, true); set(hotspot[followMenuNext].visible, true);'
      )
    },

    rvonexitvr() {
      this.pano.call(
        'set(events[vr_events].onviewchange, null); set(hotspot[followMenuPrev].visible, false); set(hotspot[followMenuNext].visible, false)'
      )
    },

    rvvrnext() {},
    rvvrprevious() {}
  }
}
</script>
